"use client"
import Link from 'next/link';
import Image from 'next/image';
import { useEffect, useState } from 'react';
import Script from 'next/script';

import { usePathname } from 'next/navigation';

  const GA_TRACKING_ID = process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_ID;
  const GOOGLE_ADS_ID = process.env.NEXT_PUBLIC_GOOGLE_ADS_ID;

export default function BlogList() {
    const [blogs, setBlogs] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState(true);

     const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [consent, setConsent] = useState(false);
    const [message, setMessage] = useState("");
  const [isPending, setIsPending] = useState(false);

  const pathname = usePathname();

 useEffect(() => {
    if (typeof window !== "undefined" && window.location.hash) {
      const id = window.location.hash.replace("#", "");
      const el = document.getElementById(id);
      if (el) {
        // Use smooth scroll
        el.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [pathname,blogs]); // re-run on navigation



    const handleSubscribe = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!consent) {
      setMessage("Please provide consent to receive updates.");
      return;
    }

    setIsPending(true);
    setMessage("");

    try {
      const response = await fetch("/api/submitQuery", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          name: name || "Newsletter Subscriber",
          mobile: mobile || null, // Optional now
          email: email,
          query: "",
          country: "",
          consentContact: true,
          marketingUpdates: true,
        }),
      });

      const data = await response.json();

      if (response.ok) {
        setMessage("Successfully subscribed!");
        setName("");
        setEmail("");
        setMobile("");
        setConsent(false);
      } else {
        setMessage(data.error || "Something went wrong.");
      }
    } catch (error) {
      console.error(error);
      setMessage("Error submitting subscription.");
    } finally {
      setIsPending(false);
    }
  };


   useEffect(() => {
    async function fetchBlogs() {
      try {
        setIsLoading(true);
        const res = await fetch("/api/blogs");
        const data = await res.json();
       
        if (data.success) {
          // Convert buffer images to data URLs
          const activeBlogs = data?.blogs?.filter((blog : any) => blog?.IsActive == 1)
          
          const blogsWithImages = activeBlogs?.map((blog: any) => {
            if (blog.Image1 && blog.Image1.type === "Buffer" && blog.Image1.data) {
              // Convert buffer to base64
              const base64 = btoa(
                new Uint8Array(blog.Image1.data).reduce(
                  (data, byte) => data + String.fromCharCode(byte),
                  ''
                )
              );
              return {
                ...blog,
                imageUrl: `data:image/jpeg;base64,${base64}`
              };
            }
            return {
              ...blog,
              imageUrl: '/placeholder-blog.jpg' // fallback image
            };
          });
          setBlogs(blogsWithImages);
        }
      } catch (error) {
        console.error("Error fetching blogs:", error);
      } finally {
        setIsLoading(false);
      }
    }
    fetchBlogs();
  }, []);
  
  // Loading state
  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <h1 className="text-3xl font-bold text-gray-900 sm:text-4xl">The GenAIPulse Insights</h1>
            <p className="mt-3 text-xl font-bold text-gray-500">Read what's latest in Artificial Intelligence and Technology</p>
          </div>
          
          <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
            {/* Skeleton loading cards */}
            {[...Array(6)].map((_, index) => (
              <div key={index} className="flex flex-col overflow-hidden rounded-lg shadow-lg bg-white">
                <div className="flex-shrink-0 h-48 relative bg-gray-200 animate-pulse"></div>
                <div className="flex-1 p-6 flex flex-col justify-between">
                  <div className="flex-1">
                    <div className="h-4 bg-gray-200 rounded w-1/4 mb-4 animate-pulse"></div>
                    <div className="h-6 bg-gray-200 rounded w-3/4 mb-2 animate-pulse"></div>
                    <div className="space-y-2">
                      <div className="h-4 bg-gray-200 rounded animate-pulse"></div>
                      <div className="h-4 bg-gray-200 rounded w-5/6 animate-pulse"></div>
                    </div>
                  </div>
                  <div className="mt-6 flex items-center">
                    <div className="flex-shrink-0">
                      <div className="h-10 w-10 rounded-full bg-gray-200 animate-pulse"></div>
                    </div>
                    <div className="ml-3 w-1/2">
                      <div className="h-4 bg-gray-200 rounded mb-2 animate-pulse"></div>
                      <div className="h-3 bg-gray-200 rounded w-2/3 animate-pulse"></div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
           <div className="mt-16 max-w-md mx-auto bg-white p-8 rounded-xl shadow-md text-center">
          <h3 className="text-2xl font-bold text-gray-800 mb-4">Subscribe to our Newsletter</h3>
          <p className="text-gray-600 mb-6">Stay updated with the latest news from GenAIPulse.</p>
          <form onSubmit={handleSubscribe} className="space-y-4">
            <input
              type="text"
              placeholder="Enter your name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
              required
            />
            <input
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
              required
            />
            <input
              type="tel"
              placeholder="Enter your mobile number (optional)"
              value={mobile}
              onChange={(e) => setMobile(e.target.value)}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
            />
            <div className="flex items-start text-left">
              <input
                type="checkbox"
                id="consent"
                checked={consent}
                onChange={() => setConsent(!consent)}
                className="mt-1 mr-2"
                required
              />
              <label htmlFor="consent" className="text-sm text-gray-700">
                I consent to receiving marketing emails, news and updates from GenAIPulse.
              </label>
            </div>
            <button
              type="submit"
              disabled={isPending}
              className="w-full px-6 py-3 bg-gradient-to-r from-indigo-600 to-purple-600 text-white font-semibold rounded-lg hover:from-indigo-700 hover:to-purple-700 transition disabled:opacity-50"
            >
              {isPending ? "Subscribing..." : "Subscribe"}
            </button>
          </form>
          {message && <p className="mt-4 text-sm text-green-400">{message}</p>}
        </div>
      </div>
    );
  }

 return (
  <div
    className="relative min-h-screen py-12 px-4 sm:px-6 lg:px-8"
    style={{
      backgroundImage: "url('/blogs-bg.jpg')",
      backgroundSize: "cover",
      backgroundPosition: "center",
    }}
  >
      {GA_TRACKING_ID && (
            <>
              <Script 
                src={`https://www.googletagmanager.com/gtag/js?id=${GA_TRACKING_ID}`}
                strategy="afterInteractive"
              />
              <Script id="google-tags" strategy="afterInteractive">
                {`
                  window.dataLayer = window.dataLayer || [];
                  function gtag(){window.dataLayer.push(arguments);}
                  gtag('js', new Date());
                  gtag('config', '${GA_TRACKING_ID}');
                  gtag('config', '${GOOGLE_ADS_ID}');
                `}
              </Script>
            </>
          )}
    {/* Light overlay with higher transparency */}
    <div className="absolute inset-0 bg-white/80"></div>

    {/* Content */}
    <div className="relative max-w-7xl mx-auto">
      <div className="text-center mb-12">
        <h1 className="text-3xl font-bold text-gray-900 sm:text-4xl">
          The GenAIPulse Insights
        </h1>
        <p className="mt-3 text-xl font-bold text-gray-700">
          Read what's latest in Artificial Intelligence and Technology
        </p>
      </div>

      <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
        {blogs?.map((blog) => (
          <div
            key={blog.Id}
            className="flex flex-col overflow-hidden rounded-lg shadow-lg bg-white hover:shadow-xl transition-shadow duration-300"
          >
            <div className="flex-shrink-0 h-48 relative">
              <Image
                src={blog.imageUrl}
                alt={blog.Name}
                fill
                className="object-cover"
                sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
              />
            </div>
            <div className="flex-1 p-6 flex flex-col justify-between">
              <div className="flex-1">
                <p className="text-sm font-medium text-indigo-600">
                  {blog.Minutes} min read
                </p>
                <Link href={`/blog/${blog.Id}`} className="block mt-2">
                  <h3 className="text-xl font-semibold text-gray-900 hover:text-indigo-600 transition-colors duration-200">
                    {blog.Name}
                  </h3>
  <p className="mt-3 text-base text-gray-500">
    {blog.Article.replace(/<[^>]*>?/gm, '').slice(0, 90)}...
  </p>
                </Link>
              </div>
              <div className="mt-6 flex items-center">
                <div className="flex-shrink-0">
                  <span className="sr-only">{blog?.Author}</span>
                  <div className="h-10 w-10 rounded-full bg-gray-200 flex items-center justify-center text-gray-600 font-medium">
                    {blog?.Author?.charAt(0)}
                  </div>
                </div>
                <div className="ml-3">
                  <p className="text-sm font-medium text-gray-900">
                    {blog?.Author}
                  </p>
                  <div className="flex space-x-1 text-sm text-gray-500">
                    <time dateTime={blog.CreatedDateTime}>
                      {new Date(blog.CreatedDateTime).toLocaleDateString(
                        "en-US",
                        {
                          year: "numeric",
                          month: "long",
                          day: "numeric",
                        }
                      )}
                    </time>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
        <div id='newsletter'  >
        <div  className="mt-16 max-w-md mx-auto  bg-gray-100  p-8 rounded-xl shadow-md text-center">
          <h3 className="text-2xl font-bold text-gray-800 mb-1">Subscribe to our Newsletter to stay updated</h3>
          {/* <p className="text-gray-600 mb-6">Stay updated with the latest news from GenAIPulse.</p> */}
          <form onSubmit={handleSubscribe} className="space-y-4">
            <input
              type="text"
              placeholder="Enter your name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
              required
            />
            <input
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
              required
            />
            <input
              type="tel"
              placeholder="Enter your mobile number (optional)"
              value={mobile}
              onChange={(e) => setMobile(e.target.value)}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
            />
            <div className="flex items-start text-left">
              <input
                type="checkbox"
                id="consent"
                checked={consent}
                onChange={() => setConsent(!consent)}
                className="mt-1 mr-2"
                required
              />
              <label htmlFor="consent" className="text-sm text-gray-700">
                I consent to receiving marketing emails, news and updates from GenAIPulse.
              </label>
            </div>
            <button
              type="submit"
              disabled={isPending}
              className="w-full px-6 py-3 bg-gradient-to-r from-indigo-600 to-purple-600 text-white font-semibold rounded-lg hover:from-indigo-700 hover:to-purple-700 transition disabled:opacity-50"
            >
              {isPending ? "Subscribing..." : "Subscribe"}
            </button>
          </form>
          {message && <p className="mt-4 text-sm text-green-400">{message}</p>}
        </div>
        </div>
    </div>

    <section className="sr-only">
  <p>
    When businesses <strong>find a web developer</strong> they can truly rely
    on, they find GenAIPulse — a company that goes beyond code to deliver
    complete digital transformation. From concept to deployment, our
    engineering teams build robust web solutions that scale with your ambition.
  </p>
  <p>
    We specialize in intelligent <strong>automation</strong> that eliminates
    repetitive workflows, reduces operational costs, and frees your team to
    focus on what matters most. Our automation frameworks integrate seamlessly
    with existing enterprise systems, making digital transitions smooth and
    measurable.
  </p>
  <p>
    At the intersection of <strong>artificial intelligence</strong> and
    business strategy, GenAIPulse designs solutions that learn, adapt, and
    evolve. We are recognized as the{" "}
    <strong>best AI agents company</strong> for enterprises seeking autonomous,
    context-aware AI systems that drive real outcomes — not just demos.
  </p>
  <p>
    Our work in <strong>healthcare</strong> is transforming how clinics,
    hospitals, and health-tech startups deliver care. From patient data
    management and diagnostic assistance to appointment automation and
    compliance reporting, GenAIPulse builds{" "}
    <strong>healthcare</strong> technology that is secure, scalable, and
    human-centered.
  </p>
  <p>
    In the rapidly evolving world of financial technology, GenAIPulse stands
    apart. As one of the{" "}
    <strong>top 10 mobile app development companies</strong> with deep roots
    in <strong>fintech</strong>, we build payment platforms, lending apps,
    investment dashboards, and digital banking solutions that meet the
    highest standards of security and user experience.
  </p>
</section>

    

    
  </div>
);

;
}